// General
const y = 'Yes';
const n = 'No';
const other = 'Other';
const unknown = 'I don’t know';
const selectAll = 'Select all that apply';
const apply = 'Apply Now';
const enroll = 'Enroll Now';
const order = 'Order Now';
const contact = 'Contact Us';
const visit = 'Visit a Branch';
const amountToBorrow = 'Amount to borrow';
const timingOfNeed = 'Timing of need';
const detailsTimingHeader = 'Timing: ';
const now = 'Immediate';
const threeMonths = '3 months';
const sixMonths = '6 months';
const oneYear = '1 year';
const overAYear = 'Over a year';
// Current Loans (loans)
const detailsLoanHeader = 'Loans: ';
const balance = 'Current balance:';
const moPayment = 'Monthly payment:';
const rate = 'Current rate:';
const rate0 = '0-2 %';
const rate2 = '2-3 %';
const rate3 = '3-4 %';
const rate4 = '4-5 %';
const rate5 = '5-6 %';
const rate6 = '6-7 %';
const rate7 = '7-8 %';
const rate8 = '8-9 %';
const rate9 = '9-10 %';
const rate10 = 'More than 10%';
// Savings (savingsGoals)
const detailsSavingsHeader = 'Savings Goals: ';
const amount = 'Total Amount to Save:';
const amountSaved = 'Amount saved to date:';
const contribution = 'Monthly Contribution:';
const frequency = 'Access to funds:';
const w = 'Weekly';
const qtr = 'Quarterly';
const m = 'Monthly';
const yr = 'Yearly';
const r = 'Rarely';
// Borrow (lendingGoals)
const detailsLendingHeader = 'Needs: ';
const borrowAmount = 'How much will you need?';
const access = 'How do you want the funds disbursed?';
const timing = 'When will you need the money?';
const timingCurrent = 'I’m currently looking';
const timingSoon = 'Within the next 6 months';
const timingYear = 'Within the next year';
const timingUnknown = 'No specific timeframe';
const disburse = 'How do you want the money disbursed?';
const disburseAll = 'All at once';
const disburseOver = 'Over time';

const firstName = "First Name";
const lastName = "Last Name";
const email = "Email";
const phone = "Phone Number";

const year = new Date().getFullYear();

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */
  'error.title': 'Error',
  'error.question.required': 'Must be answered',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.question.postalCode': 'Please enter a valid zip code',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  'header.menu.goToBeginning': 'Go to beginning',

  'footer.copyright': `Copyright © ${year} Commerce Bancshares, Inc. All rights reserved. Commerce Bank: Member FDIC`,
  'guide.name': '@ignitesales/commerce',
  'nav.prev': 'Back',
  'nav.next': 'Next',

  pleaseSelect: 'Please Select',

  'landing.title': 'Let us help you',
  'landing.message':
    'Thanks for choosing Commerce Bank for your business banking needs. First, let’s get to know more about your and your business by answering a few questions.',
  'landing.getStarted': "Let's Get Started",

  'products.disclosures': 'Disclosures',
  'products.features.title': 'Why this product?',
  'products.seeMore': 'See more',
  'products.interestedNow': 'Interested Now',
  'products.interested': 'Interested',
  'productGroup.checking': 'Checking Products',
  'productGroup.savings': 'Savings Products',

  'summary.companyInfo.title': 'Your Company Information',
  'summary.contactInfo.title': 'Your Contact Information',
  'summary.shoppingCart.productsTitle': 'Your products',
  'summary.companyInfo.none': 'Not Available',
  'summary.page.title': 'Here are your Personalized Commerce Banking Products',
  'summary.page.cta': 'Send to Insight360',
  'summary.recommendations.title': 'We recommend these products:',
  'summary.answers.title': 'Your Answers',
  'summary.answers.cta': 'See your answers',
  'summary.return.cta': 'Back to Start',
  'summary.end': 'Contact Me',
  'summary.schedule': 'Schedule an Appointment',
  'summary.mobile': 'Text',
  'summary.email': 'Email',
  'summary.print': 'Print',
  'summary.sendToInsight.success.title': 'Information sent to Insight360 successfully!',
  'summary.sendToInsight.success.message':  'Email sent to Banker.',
  'summary.sendToInsight.error.title': 'Error sending information to Insight360.',
  'summary.sendToInsight.error.message': 'Email sent to Banker.',
  'summary.sendToInsight.noInfo.error.title': 'Missing Information',
  'summary.sendToInsight.noInfo.error.message': 'Please provide company/contact information to continue.',
  'summary.sendToInsight.status': 'Latest Information Sent',
  'summary.enrollmentQRCode.title': 'QR Code for Online Banking Enrollment',
  'summary.updated': 'Your recommendation #{uuid} was updated {date}',
  'details.recommendations': 'Your Recommendations',
  'details.answers': 'Your Answers',

  'product.why': 'Why Best?',
  'product.existing': '> Congratulations, you are already in the correct product',
  'product.info': 'Info',
  'product.addOns': 'Services and Products included',
  'product.resources': 'See all resources',
  'product.trends': 'See resources',
  'product.disclosure.title': 'Disclosures',

  'businessTrends.count': 4,

  'share.submitted.confirmation': 'OK',


  'shareViaEmail.title': 'Email My Results',
  'shareViaEmail.submitted': 'Your email has been successfully sent',
  'shareViaEmail.label': 'Email address',
  'shareViaEmail.button': 'Send Email',

  'shareViaSms.title': 'Text My Results',
  'shareViaSms.submitted': 'Your message has been successfully sent',
  'shareViaSms.message':
    'Access your results below:',
  'shareViaSms.label': 'Phone Number',
  'shareViaSms.button': 'Send Text',
  'shareViaSms.placeholder': '(555) 123-4567',
  'shareViaEmailComplete.message': 'Email sent to banker',

  'sendToInsightComplete.modal.title': 'Success!',
  'sendToInsightComplete.message': 'Email sent to banker',

  'contactMe.workingWithBankerOrBranch': 'Are you currently working with a Banker or Branch?',
  'contactMe.workingWithBankerOrBranch.placeholder': 'Banker or Branch Name',
  'contactMe.workingWithBankerOrBranch.error': 'Banker or Branch name is invalid.',
  'contactMe.additionalComments': 'Additional Comments',
  'contactMe.additionalComments.placeholder': 'Additional Comments',
  'contactMe.additionalComments.error': 'Additional comments text is invalid.',

  'formInput.firstName.placeholder': firstName,
  'formInput.lastName.placeholder': lastName,
  'formInput.email.placeholder': email,
  'formInput.phone.placeholder': phone,
  'formInput.workingWithBankerOrBranch.placeholder': 'Banker or Branch Name',
  'formInput.additionalComments.placeholder': 'Additional Comments',
  'formInput.error.required': 'Required',
  'formInput.error.validate': 'Please enter a valid phone number',
  'formInput.error.pattern': 'Please enter a valid email',

  'editCompany.formInput.state.error.pattern': 'Please enter two letter state',
  'editCompany.formInput.zipCode.error.pattern': 'Please enter a five digit zip code',
  'addCompany.formInput.state.error.pattern': 'Please enter two letter state',
  'addCompany.formInput.zipCode.error.pattern': 'Please enter a five digit zip code',
  'addCompany.formInput.companyName.error.maxLength': 'Must be 35 characters or less',
  'editCompany.formInput.companyName.error.maxLength': 'Must be 35 characters or less',

  'contactMeForm.header': 'Before You Schedule',
  'contactMeForm.contactUsHeader': 'Share Your Result With US',
  'contactMeForm.formInput.firstName': firstName,
  'contactMeForm.formInput.lastName': lastName,
  'contactMeForm.formInput.email': email,
  'contactMeForm.formInput.phone': phone,
  'contactMeForm.formInput.workingWithBankerOrBranch': 'Are you currently working with a Banker or Branch?',
  'contactMeForm.formInput.additionalComments': 'Additional Comments',
  'contactMeForm.formInput.preferredMethodOfContact': 'Preferred Method of Contact',
  'contactMeForm.openAccount': 'Before you apply, we invite you to share your results with us!  When you provide your name, email, and phone number, we’ll keep track of your recommendation and send you a copy by email. Submit your info to continue to the application.',
  'contactMeForm.contactUs': 'Before you contact us, please share your results with us by submitting the form below. We’ll link your name, email, and phone number to your answers so we can better help you when you get in touch. We’ll also email you a copy of your recommendation. Submit your info to get our contact information.',
  'contactMeForm.contactLoanTeam': 'Before you contact our home loan team, please share your results with us by submitting the form below. We’ll link your name, email, and phone number to your answers so we can better help you when you get in touch. We’ll also email you a copy of your recommendation. Submit your info to get our contact information.',
  'interestedNow': 'Interested Now',
  'maybeLater': 'Maybe Later',

  'lookupFlow.back': 'Back',
  'lookupFlow.continue': 'Continue',
  'lookupFlow.noCompanyFound.header': 'No Company Found',
  'lookupFlow.noCompanyFound.text': 'Please search again, or add a new company.',
  'lookupFlow.noCompanyFound.addCompany': 'Add Company',
  'lookupFlow.noContactFound.header': 'No Contact Found',
  'lookupFlow.noContactFound.text': 'Please search again, or add a new contact.',
  'lookupFlow.noContactFound.addContact': 'Add Contact',
  'lookupFlow.resultsFound': 'results found',
  'lookupFlow.save': 'Save',
  'lookupFlow.search': 'Search',
  'lookupFlow.companyResults.title': 'Select your Company:',
  'lookupFlow.companyResults.addButton': 'Add Company',
  'lookupFlow.contactResults.title': 'Select your Contact:',
  'lookupFlow.contactResults.addButton': 'Add Contact',
  'lookupFlow.addCompany.title': 'Enter Company Information:',
  'lookupFlow.addContact.title': 'Enter Contact Information:',
  'lookupFlow.editCompany.title': 'Enter Company Information:',
  'lookupFlow.editContact.title': 'Enter Contact Information:',

  /**
   * ============================
   * Entry
   * ============================
   */


   "companyLookup": "Company Lookup",
   "contactLookup": "Contact Lookup",
  "formInput.companyName.placeholder": 'Company Name',
  "formInput.streetAddress.placeholder": 'Street Address',
  "formInput.city.placeholder": 'City',
  "formInput.state.placeholder": 'State',
  "formInput.zipCode.placeholder": 'Zip',
  "formInput.companyPhone.placeholder": 'Company Phone Number',
  "formInput.firstName.placeholder": firstName,
  "formInput.lastName.placeholder": lastName,
  "formInput.contactPhone.placeholder": 'Contact Phone Number',
  "formInput.email.placeholder": email,

  "bankingRelationship-group": "Help me understand more about your banking relationships.",
  "bankingRelationship": "Do you currently have accounts with Commerce Bank?",
  "bankingRelationship.business": "Yes, only business",
  "bankingRelationship.personal": "Yes, only personal",
  "bankingRelationship.both": "Yes, both",
  "bankingRelationship.none": "No, not yet",

  "visitReason": "Tell me more about why you came in today so I can better serve you",
  "visitReason.newAccount": "Open a new account",
  "visitReason.applyLoan": "Apply for a loan",
  "visitReason.paymentOptions": "Learn more about payment options",
  "visitReason.none": "Learn more about all Small Business offerings",

  'primaryBankName-group': 'Help me understand more about your banking relationships.',
  primaryBankName: 'Where is your current personal banking relationship?',
  'primaryBankName.AcademyBank': 'Academy Bank',
  'primaryBankName.Arvest': 'Arvest',
  'primaryBankName.BankMidwest': 'Bank Midwest',
  'primaryBankName.BankofAmerica': 'Bank of America',
  'primaryBankName.BMOHarris': 'BMO Harris',
  'primaryBankName.BuseyBank': 'Busey Bank',
  'primaryBankName.CapitolFederal': 'Capitol Federal',
  'primaryBankName.CentralBank': 'Central Bank',
  'primaryBankName.Chase': 'Chase',
  'primaryBankName.Citibank': 'Citibank',
  'primaryBankName.Citizens': 'Citizens',
  'primaryBankName.CommerceBank': 'Commerce Bank',
  'primaryBankName.CommunityAmerica': 'Community America',
  'primaryBankName.CountryClubBank': 'Country Club Bank',
  'primaryBankName.Emprise': 'Emprise',
  'primaryBankName.EnterpriseBankTrust': 'Enterprise Bank & Trust',
  'primaryBankName.Fidelity': 'Fidelity',
  'primaryBankName.FirstBank': 'First Bank',
  'primaryBankName.FirstFederal': 'First Federal',
  'primaryBankName.GoldenPlainsCreditUnion': 'Golden Plains Credit Union',
  'primaryBankName.GreatSouthernBank': 'Great Southern Bank',
  'primaryBankName.HannibalNationalBank': 'Hannibal National Bank',
  'primaryBankName.Intrust': 'Intrust',
  'primaryBankName.KansasStateBank': 'Kansas State Bank',
  'primaryBankName.KansasStateFederalCreditUnion': 'Kansas State Federal Credit Union',
  'primaryBankName.LandmarkBank': 'Landmark Bank',
  'primaryBankName.LeadBank': 'Lead Bank',
  'primaryBankName.MazumaCreditUnion': 'Mazuma Credit Union',
  'primaryBankName.MOBank': 'MO Bank',
  'primaryBankName.MortonCommunity': 'Morton Community',
  'primaryBankName.NBKC': 'NBKC',
  'primaryBankName.NodawayValleyBank': 'Nodaway Valley Bank',
  'primaryBankName.PNCBank': 'PNC Bank',
  'primaryBankName.RegionsBank': 'Regions Bank',
  'primaryBankName.SecurityBankofKansasCity': 'Security Bank of Kansas City',
  'primaryBankName.Simmons': 'Simmons',
  'primaryBankName.SunflowerBank': 'Sunflower Bank',
  'primaryBankName.TiptonLathamBank': 'Tipton Latham Bank',
  'primaryBankName.UMB': 'UMB',
  'primaryBankName.USBank': 'US Bank',
  'primaryBankName.USAA': 'USAA',
  'primaryBankName.WellsFargo': 'Wells Fargo',
  'primaryBankName.Other': 'Other',
  'primaryBankName.None': 'None',

  'primaryBusinessBankName-group': 'Help me understand more about your business.',
  primaryBusinessBankName: 'Where is your current business banking relationship?',
  'primaryBusinessBankName.AcademyBank': 'Academy Bank',
  'primaryBusinessBankName.Arvest': 'Arvest',
  'primaryBusinessBankName.BankMidwest': 'Bank Midwest',
  'primaryBusinessBankName.BankofAmerica': 'Bank of America',
  'primaryBusinessBankName.BMOHarris': 'BMO Harris',
  'primaryBusinessBankName.BuseyBank': 'Busey Bank',
  'primaryBusinessBankName.CapitolFederal': 'Capitol Federal',
  'primaryBusinessBankName.CentralBank': 'Central Bank',
  'primaryBusinessBankName.Chase': 'Chase',
  'primaryBusinessBankName.Citibank': 'Citibank',
  'primaryBusinessBankName.Citizens': 'Citizens',
  'primaryBusinessBankName.CommerceBank': 'Commerce Bank',
  'primaryBusinessBankName.CommunityAmerica': 'Community America',
  'primaryBusinessBankName.CountryClubBank': 'Country Club Bank',
  'primaryBusinessBankName.Emprise': 'Emprise',
  'primaryBusinessBankName.EnterpriseBankTrust': 'Enterprise Bank & Trust',
  'primaryBusinessBankName.Fidelity': 'Fidelity',
  'primaryBusinessBankName.FirstBank': 'First Bank',
  'primaryBusinessBankName.FirstFederal': 'First Federal',
  'primaryBusinessBankName.GoldenPlainsCreditUnion': 'Golden Plains Credit Union',
  'primaryBusinessBankName.GreatSouthernBank': 'Great Southern Bank',
  'primaryBusinessBankName.HannibalNationalBank': 'Hannibal National Bank',
  'primaryBusinessBankName.Intrust': 'Intrust',
  'primaryBusinessBankName.KansasStateBank': 'Kansas State Bank',
  'primaryBusinessBankName.KansasStateFederalCreditUnion': 'Kansas State Federal Credit Union',
  'primaryBusinessBankName.LandmarkBank': 'Landmark Bank',
  'primaryBusinessBankName.LeadBank': 'Lead Bank',
  'primaryBusinessBankName.MazumaCreditUnion': 'Mazuma Credit Union',
  'primaryBusinessBankName.MOBank': 'MO Bank',
  'primaryBusinessBankName.MortonCommunity': 'Morton Community',
  'primaryBusinessBankName.NBKC': 'NBKC',
  'primaryBusinessBankName.NodawayValleyBank': 'Nodaway Valley Bank',
  'primaryBusinessBankName.PNCBank': 'PNC Bank',
  'primaryBusinessBankName.RegionsBank': 'Regions Bank',
  'primaryBusinessBankName.SecurityBankofKansasCity': 'Security Bank of Kansas City',
  'primaryBusinessBankName.Simmons': 'Simmons',
  'primaryBusinessBankName.SunflowerBank': 'Sunflower Bank',
  'primaryBusinessBankName.TiptonLathamBank': 'Tipton Latham Bank',
  'primaryBusinessBankName.UMB': 'UMB',
  'primaryBusinessBankName.USBank': 'US Bank',
  'primaryBusinessBankName.USAA': 'USAA',
  'primaryBusinessBankName.WellsFargo': 'Wells Fargo',
  'primaryBusinessBankName.Other': 'Other',
  'primaryBusinessBankName.None': 'None',

  "industry-group": "",
  "industry": "Which industry best describes your business?",
  "industry.agriculture": "Agriculture, Forestry & Fishing",
  'industry.construction': 'Construction',
  'industry.finance': 'Finance/Insurance',
  'industry.government': 'Government',
  'industry.healthcare': 'Healthcare',
  'industry.foodServices': 'Food Services',
  'industry.hospitality': 'Hospitality',
  'industry.informationTechnology': 'Information Technology',
  'industry.legal': 'Legal',
  'industry.manufacturing': 'Manufacturing',
  'industry.mining': 'Mining / Oil & Gas',
  'industry.personalServices': 'Personal Services',
  'industry.professionalServices': 'Professional Services',
  'industry.publicAdministration': 'Public Administration',
  'industry.publicUtilities': 'Public Utilities',
  'industry.publishing': 'Publishing and Broadcasting',
  'industry.realEstate': 'Real Estate',
  'industry.religious': 'Religious/Civic Organization',
  'industry.repair': 'Repair and Maintenance',
  'industry.retail': 'Retail Trade',
  'industry.scienceEngineering': 'Science/Engineering',
  'industry.telecommunications': 'Telecommunications',
  'industry.transportation': 'Transportation/Warehousing',
  'industry.utilities': 'Utilities',
  'industry.wholesaleTrade': 'Wholesale Trade',
  'industry.other': 'Other',
  "businessStructure": "Tell us about your business structure",
  "businessStructure.sole": "Sole proprietorship",
  "businessStructure.scorp": "S Corporation",
  "businessStructure.ccorp": "C Corporation",
  "businessStructure.llc": "Limited Liability Company (LLC)",
  "businessStructure.llp": "Limited Liability Partnership (LLP)",
  "businessStructure.nonprofit": "Non-Profit",
  "businessStructure.trust": "Trust",
  "businessStructure.association": "Association/Organization",
  "businessStructure.other": "Other",
  "businessInfo-group": "",
  "businessControl": "What is your main role with the company?",
  "businessControl.sole": "Sole or Majority Owner",
  "businessControl.nonMajor": "Non-Majority Owner",
  "businessControl.emp": "An Employee",
  "businessInfo2-group": "",
  "businessAbout": "Tell me about your business.",
  "businessAbout.tooltip": "Customer alma mater, business details, family, specifics about business not captured in previous questions",
  "businessAbout.textarea.charactersRemaining": "character(s) remaining",
  "businessAge": "How many years have you been in business?",
  "numberOfEmpoyees": "How many employees does your business have, including you?",
  "businessInfo3-group": "",
  "annualRevenue": "What is your estimated annual revenue for this year?",
  "postalCode": "Where is your business located? (zip)",
  "collectPayments-group": "The way you invoice and receive payments from your customers has a direct impact on your cashflow so I would like to better understand how you get paid. How do you receive payments from your customers each month?",
  "collectPayments-group.subtext": "Average for each collection method.",
  "collectChecks": "Number of Checks",
  "collectCards": "Number of Debit / Credit Cards",
  "collectAch": "Number of ACHs",
  "collectAch.tooltip": "Money received electronically into your account from another party's account that typically repeats on a regular basis. Examples: payments from customers, collecting membership dues, monthly service fees, etc.",
  "collectCash": "Number of Person to Person / Cash",
  "largeChecks": "To determine whether mobile or remote deposit is the best fit for your business, do you deposit checks greater than $7,500?",
  "largeChecks.true": "Yes",
  "largeChecks.false": "No",
  "deposits-group": "",
  "depositTypes.subtext": selectAll,
  "depositTypes": "How do you make your deposits?",
  "depositTypes.branch": "In the branch",
  "depositTypes.mobile": "Mobile Deposit",
  "depositTypes.scanner": "Remote Desktop Scanner",
  "depositTypes.atm": "ATM",
  "depositFrequency": "How often do you make a deposit?",
  "depositFrequency.tooltip": "This includes the number of times you make a deposit at an ATM, on a mobile device, or desktop check scanner.",
  "depositFrequency.daily": "Daily",
  "depositFrequency.weekly": "Weekly",
  "depositFrequency.monthly": "Monthly",
  "depositAmount-group": "",
  "depositAmount": "How much cash do you deposit during an average month?",
  "depositsNum-group": "",
  "depositNumWeekly": "How many times a week do you make a deposit?",
  "depositNumMonthly": "How many times a month do you make a deposit?",
  "billingFeatures-group": "",
  "billingFeatures.subtext": selectAll,
  "billingFeatures": "Do you currently use any of the following to help with your invoicing process?",
  "billingFeatures.recurringInvoices": "Ability to set-up recurring invoicing",
  "billingFeatures.electronicInvoice": "Electronic invoicing",
  "billingFeatures.multiUser": "Multi-user access",
  "billingFeatures.multiUser.tooltip": "Choose from 4 additional user roles with varying degrees of access and authorities, none of which provide access to the bank account",
  "billingFeatures.autoCharge": "Auto charge customer’s bank account or credit card",
  "billingFeatures.none": "None of the above",
  "creditCards-group": "",
  "acceptCreditCards": "Would you like to accept credit/debit card payments from your customers?",
  "acceptCreditCards.yes": "Yes",
  "acceptCreditCards.no": "No",
  "creditMethod": "How do you currently accept card payments?",
  "creditMethod.subtext": selectAll,
  "creditMethod.online": "Online",
  "creditMethod.person": "In person",
  "creditMethod.phone": "Over the phone",
  "creditMethod.other": "Other",
  "processCards": "Do you process cards through Commerce Bank Merchant Services or a different company?",
  "processCards.commerce": "Commerce Merchant Services",
  "processCards.other": "A different company for Merchant Services",
  "processCardsCompany-group": "Managing your card payments.",
  "processCardsCompany":"Which company do you use for your Merchant Services?",
  "payments-group": "Let's discuss paying your bills - how do you pay others each month?",
  "payments-group.subtext": "Average for each payment method.",
  "checkPayments": "Number of Checks",
  "debitCardPayments": "Number of Debit Card Payments",
  "businessCreditCardPayments": "Number of Credit Card Payments",
  "wiresPayments": "Number of Wires",
  "achPayments": "Number of ACHs",
  "achPayments.tooltip": "Money paid electronically to other parties directly from your account.  Examples: monthly payments to vendors, employees, government entities, etc.",
  "paymentsAmount": "Monthly, what amount do you pay others via cash, checks, P2P, and ACH payments?",
  "paymentsAmount.tooltip": "I.e., on average you spend a total of $2,000 each month paying others through cash, check, person to person and ACH. So you would enter $2,000 here.",
  "billPayCardTypes-group":"",
  "billPayCardTypes":"What type of card(s) are you using for credit and debit card payments? ",
  "billPayCardTypes.subtext": selectAll,
  "billPayCardTypes.businessCredit":"Business Credit Card",
  "billPayCardTypes.personalCredit":"Personal Credit Card",
  "billPayCardTypes.businessDebit":"Business Debit Card",
  "billPayCardTypes.personalDebit":"Personal Debit Card",
  "billPayFeatures-group": "",
  "billPayFeatures": "When your company pays bills, do you use any of the following?",
  "billPayFeatures.subtext": selectAll,
  "billPayFeatures.recurring": "Recurring bill payment",
  "billPayFeatures.multiUser": "Multi-user access",
  "billPayFeatures.multiUser.tooltip": "Providing online access to additional users in your organization who are involved in the invoicing process.",
  "billPayFeatures.approval": "A bill approval workflow process",
  "billPayFeatures.approval.tooltip": "A process in which one or more individuals must approve a bill before payment can be made.",
  "billPayFeatures.none": "None of the Above",
  "billPayFeatures2-group": "",
  "software": "What accounting software does your company currently use?",
  "software.quickbooks": "QuickBooks",
  "software.xero": "Xero",
  "software.netsuite": "NetSuite",
  "software.intacct": "Intacct",
  "software.other": "Other",
  "software.no": "None",
  "billPayFeatures3-group": "",
  "softwareLearnMore":"Are you interested in learning more about accounting software packages?",
  "softwareLearnMore.yes":"Yes",
  "softwareLearnMore.no":"No",
  "averageBalances-group": 'Understanding your balances both at Commerce and elsewhere allows me to recommend the right products to help run your business. What do you estimate the minimum balances that you will keep in your business accounts with Commerce?',
  "averageChecking": "Checking",
  "averageSavings": "Savings and Money Markets",
  "averageCDs": "CDs",
  "personalBalancesCommerce-group": "What are the estimated balances in your personal accounts at Commerce?",
  "personalBalancesCommerce-group.tooltip": "If they do not have personal accounts with Commerce, enter Zero",
  "commercePersonalChecking": "Checking",
  "commercePersonalSavings": "Savings, Money Markets, CDs",
  "commercePersonalIra": "IRA Accounts",
  "personalBalancesExternal-group": "What are the estimated balances in your personal accounts outside of Commerce?",
  "personalBalancesExternal-group.tooltip": "If they do not have personal accounts outside of Commerce, enter Zero",
  "externalPersonalChecking": "Checking",
  "externalPersonalSavings": "Savings, Money Markets, CDs",
  "externalPersonalIra": "IRA Accounts",
  "combinedAccountBalance": "Combined Deposit Balance",
  "combinedAccountBalance.info": "Your average balances",

  "moreAccountInfo": "We use personal account information to help you with more than just your business. Plus, there are benefits to having both that save you money. May I ask you a couple more questions about your personal accounts?",
  "moreAccountInfo.true": "Yes",
  "moreAccountInfo.false": "No",
  "anticipatedCheckingBalance": "If you were to open a personal checking account with us, what do you anticipate that average balance will be?",
  "anticipatedCheckingBalance.5kPlus": "$5,000 +",
  "anticipatedCheckingBalance.1k": "$1,000 to $5,000",
  "anticipatedCheckingBalance.less1k": "$0 to $1,000",
  "anticipatedDepositType": "How does money come into your accounts?",
  "anticipatedDepositType.subtext": selectAll,
  "anticipatedDepositType.directDeposit": "Direct deposit",
  "anticipatedDepositType.check": "Check",
  "anticipatedDepositType.cash": "Cash",
  "anticipatedDepositType.transfer": "Transfers",
  "anticipatedDepositType.other": "Other",
  "monthlyDirectDeposit500": "Do you expect to have a monthly personal direct deposit of at least $500?",
  "monthlyDirectDeposit500.true": "Yes",
  "monthlyDirectDeposit500.false": "No",

  "businessLoans-group": "Understanding your balances will help us find the right accounts for you and your business.",
  "cardBenefit": "We offer two types of credit cards. To help us determine which one is best for your business, I’d like to understand which you value most",
  "cardBenefit.rewards": "Rewards or Cash Back",
  "cardBenefit.lowInterest": "Low Interest Rate",
  "cardBenefit.none": "Neither, I don't use credit cards",
  "hasCurrentLoans":"Does your business have any current loans?",
  "hasCurrentLoans.yes":"Yes",
  "hasCurrentLoans.no":"No",
  "additionalFunds-group": "The goals for your business.",
  "addtionalFunds": "Over the next 12 months, do you foresee a need for additional funds to expand your business?",
  "addtionalFunds.yes": "Yes",
  "addtionalFunds.no": "No, thanks",
  "businessExpansion-group": '',
  'businessExpansion-group.newBusinessCustomer': 'As you see your business growing, what type of needs do you foresee?',
  'businessExpansion-group.existingBusinessCustomer': 'Tell me more about your lending needs.',
  'businessExpansion-group.existingBusinessCustomer.tooltip': 'This includes current and future lending needs.',
  'businessExpansion': 'Let’s discuss the future goals for your business.',
  'businessExpansion-group.subtext': selectAll,
  expansionNeeds: 'Loan Type:',
  'expansionNeeds.cardBuilder.modal.title': 'As you see your business growing, what type of needs do you foresee?',
  'expansionNeeds.cardBuilder.addCard': 'Add Expansion',
  'expansionNeeds.cardBuilder.cancelEdit': 'Cancel',
  'expansionNeeds.cardBuilder.saveCard': 'Save',
  'expansionNeeds.cardBuilder.editCard': 'Edit',
  'expansionNeeds.cardBuilder.removeCard': 'Remove',

  'expansionNeeds.capital': 'Need for working capital',
  'expansionNeeds.capital.icon': '/classpath/assets/images/icons/icon-bank-check.svg',
  'capital.cardBuilder.title': 'Need for working capital',
  capital_amount: amountToBorrow,
  capital_timing: timingOfNeed,
  'capital_timing.1': now,
  'capital_timing.3': threeMonths,
  'capital_timing.6': sixMonths,
  'capital_timing.12': oneYear,
  'capital_timing.13': overAYear,
  'details.capital_amount': `Amount to Borrow: Need for working capital`,
  'details.capital_timing': `${detailsTimingHeader} Need for working capital`,

  'expansionNeeds.cashFlow': 'Increase in cash flow',
  'expansionNeeds.cashFlow.icon': '/classpath/assets/images/icons/icon-dollars.svg',
  'cashFlow.cardBuilder.title': 'Increase in cash flow',
  cashFlow_amount: amountToBorrow,
  cashFlow_timing: timingOfNeed,
  'cashFlow_timing.1': now,
  'cashFlow_timing.3': threeMonths,
  'cashFlow_timing.6': sixMonths,
  'cashFlow_timing.12': oneYear,
  'cashFlow_timing.13': overAYear,
  'details.cashFlow_amount': `Amount to Borrow: Increase in cash flow`,
  'details.cashFlow_timing': `${detailsTimingHeader} Increase in cash flow`,

  'expansionNeeds.acquisition': 'Business acquisition',
  'expansionNeeds.acquisition.icon': '/classpath/assets/images/icons/icon-airplane.svg',
  'acquisition.cardBuilder.title': 'Business acquisition',
  acquisition_amount: amountToBorrow,
  acquisition_timing: timingOfNeed,
  'acquisition_timing.1': now,
  'acquisition_timing.3': threeMonths,
  'acquisition_timing.6': sixMonths,
  'acquisition_timing.12': oneYear,
  'acquisition_timing.13': overAYear,
  'details.acquisition_amount': `Amount to Borrow: Business acquisition`,
  'details.acquisition_timing': `${detailsTimingHeader} Business acquisition`,

  'expansionNeeds.realEstatePurchase': 'Real estate purchase',
  'expansionNeeds.realEstatePurchase.icon': '/classpath/assets/images/icons/icon-home-loan.svg',
  'realEstatePurchase.cardBuilder.title': 'Real estate purchase',
  realEstatePurchase_amount: amountToBorrow,
  realEstatePurchase_timing: timingOfNeed,
  'realEstatePurchase_timing.1': now,
  'realEstatePurchase_timing.3': threeMonths,
  'realEstatePurchase_timing.6': sixMonths,
  'realEstatePurchase_timing.12': oneYear,
  'realEstatePurchase_timing.13': overAYear,
  'details.realEstatePurchase_amount': `Amount to Borrow: Real estate purchase`,
  'details.realEstatePurchase_timing': `${detailsTimingHeader} Real estate purchase`,

  'expansionNeeds.vehiclePurchase': 'Vehicle / Equipment purchase',
  'expansionNeeds.vehiclePurchase.icon': '/classpath/assets/images/icons/icon-auto-loan.svg',
  'vehiclePurchase.cardBuilder.title': 'Vehicle / Equipment purchase',
  vehiclePurchase_amount: amountToBorrow,
  vehiclePurchase_timing: timingOfNeed,
  'vehiclePurchase_timing.1': now,
  'vehiclePurchase_timing.3': threeMonths,
  'vehiclePurchase_timing.6': sixMonths,
  'vehiclePurchase_timing.12': oneYear,
  'vehiclePurchase_timing.13': overAYear,
  'details.vehiclePurchase_amount': `Amount to Borrow: Vehicle / Equipment purchase`,
  'details.vehiclePurchase_timing': `${detailsTimingHeader} Vehicle / Equipment purchase`,

  'expansionNeeds.vehicleRefinance': 'Vehicle / Equipment refinance',
  'expansionNeeds.vehicleRefinance.icon': '/classpath/assets/images/icons/icon-retirement.svg',
  'vehicleRefinance.cardBuilder.title': 'Vehicle / Equipment refinance',
  vehicleRefinance_amount: amountToBorrow,
  vehicleRefinance_timing: timingOfNeed,
  'vehicleRefinance_timing.1': now,
  'vehicleRefinance_timing.3': threeMonths,
  'vehicleRefinance_timing.6': sixMonths,
  'vehicleRefinance_timing.12': oneYear,
  'vehicleRefinance_timing.13': overAYear,
  'details.vehicleRefinance_amount': `Amount to Borrow: Vehicle / Equipment refinance`,
  'details.vehicleRefinance_timing': `${detailsTimingHeader} Vehicle / Equipment refinance`,

  'expansionNeeds.lineOfCreditRefinance': 'Line of Credit refinance',
  'expansionNeeds.lineOfCreditRefinance.icon': '/classpath/assets/images/icons/icon-home-loan.svg',
  'lineOfCreditRefinance.cardBuilder.title': 'Line of Credit refinance',
  lineOfCreditRefinance_amount: amountToBorrow,
  lineOfCreditRefinance_timing: timingOfNeed,
  'lineOfCreditRefinance_timing.1': now,
  'lineOfCreditRefinance_timing.3': threeMonths,
  'lineOfCreditRefinance_timing.6': sixMonths,
  'lineOfCreditRefinance_timing.12': oneYear,
  'lineOfCreditRefinance_timing.13': overAYear,
  'details.lineOfCreditRefinance_amount': `Amount to Borrow: Line of Credit refinance`,
  'details.lineOfCreditRefinance_timing': `${detailsTimingHeader} Line of Credit refinance`,

  'expansionNeeds.other': 'Other',
  'expansionNeeds.other.icon': '/classpath/assets/images/icons/icon-calendar.svg',
  'other.cardBuilder.title': 'Other',
  other_amount: amountToBorrow,
  other_timing: timingOfNeed,
  'other_timing.1': now,
  'other_timing.3': threeMonths,
  'other_timing.6': sixMonths,
  'other_timing.12': oneYear,
  'other_timing.13': overAYear,
  'details.other_amount': `Amount to Borrow: Other`,
  'details.other_timing': `${detailsTimingHeader} Other`,

  'expansionNeeds.none': 'None',
  'expansionNeeds.none.icon': '/classpath/assets/images/icons/icon-close.svg',

  'currentLoans-group': 'Tell us about your current loans?',
  currentLoans: 'Loan Type:',
  'currentLoans.cardBuilder.modal.title': 'What loans do you currently have?',
  'currentLoans.cardBuilder.addCard': 'Add Existing Loan',
  'currentLoans.cardBuilder.cancelEdit': 'Cancel',
  'currentLoans.cardBuilder.saveCard': 'Save',
  'currentLoans.cardBuilder.editCard': 'Edit',
  'currentLoans.cardBuilder.removeCard': 'Remove',

  'currentLoans.realEstateLoan': 'Real Estate Loan',
  'currentLoans.realEstateLoan.icon': '/classpath/assets/images/icons/icon-piggy-bank.svg',
  'realEstateLoan.cardBuilder.title': 'Real Estate Loan',
  realEstateLoan_currentBalance: balance,
  realEstateLoan_monthlyPayment: moPayment,
  realEstateLoan_currentRate: rate,
  'realEstateLoan_currentRate.0to2': rate0,
  'realEstateLoan_currentRate.2to3': rate2,
  'realEstateLoan_currentRate.3to4': rate3,
  'realEstateLoan_currentRate.4to5': rate4,
  'realEstateLoan_currentRate.5to6': rate5,
  'realEstateLoan_currentRate.6to7': rate6,
  'realEstateLoan_currentRate.7to8': rate7,
  'realEstateLoan_currentRate.8to9': rate8,
  'realEstateLoan_currentRate.9to10': rate9,
  'realEstateLoan_currentRate.10plus': rate10,
  'realEstateLoan_currentRate.unknown': unknown,
  'realEstateLoan_provider': 'Who is this loan with?',
  'realEstateLoan_provider.commerce': 'Commerce',
  'realEstateLoan_provider.other': other,
  'details.realEstateLoan_currentRate': `${detailsLoanHeader} Real Estate Loan | ${rate}`,

  'currentLoans.businessLoan': 'Business Loan',
  'currentLoans.businessLoan.icon': '/classpath/assets/images/icons/icon-dollars.svg',
  'businessLoan.cardBuilder.title': 'Business Loan',
  businessLoan_currentBalance: balance,
  businessLoan_monthlyPayment: moPayment,
  businessLoan_currentRate: rate,
  'businessLoan_currentRate.0to2': rate0,
  'businessLoan_currentRate.2to3': rate2,
  'businessLoan_currentRate.3to4': rate3,
  'businessLoan_currentRate.4to5': rate4,
  'businessLoan_currentRate.5to6': rate5,
  'businessLoan_currentRate.6to7': rate6,
  'businessLoan_currentRate.7to8': rate7,
  'businessLoan_currentRate.8to9': rate8,
  'businessLoan_currentRate.9to10': rate9,
  'businessLoan_currentRate.10plus': rate10,
  'businessLoan_currentRate.unknown': unknown,
  'businessLoan_provider': 'Who is this loan with?',
  'businessLoan_provider.commerce': 'Commerce',
  'businessLoan_provider.other': other,
  'details.businessLoan_currentRate': `${detailsLoanHeader} Business Loan | ${rate}`,

  'currentLoans.businessLineOfCredit': 'Business Line of Credit',
  'currentLoans.businessLineOfCredit.icon': '/classpath/assets/images/icons/icon-airplane.svg',
  'businessLineOfCredit.cardBuilder.title': 'Business Line of Credit',
  businessLineOfCredit_currentBalance: balance,
  businessLineOfCredit_monthlyPayment: moPayment,
  businessLineOfCredit_currentRate: rate,
  'businessLineOfCredit_currentRate.0to2': rate0,
  'businessLineOfCredit_currentRate.2to3': rate2,
  'businessLineOfCredit_currentRate.3to4': rate3,
  'businessLineOfCredit_currentRate.4to5': rate4,
  'businessLineOfCredit_currentRate.5to6': rate5,
  'businessLineOfCredit_currentRate.6to7': rate6,
  'businessLineOfCredit_currentRate.7to8': rate7,
  'businessLineOfCredit_currentRate.8to9': rate8,
  'businessLineOfCredit_currentRate.9to10': rate9,
  'businessLineOfCredit_currentRate.10plus': rate10,
  'businessLineOfCredit_currentRate.unknown': unknown,
  'businessLineOfCredit_provider': 'Who is this loan with?',
  'businessLineOfCredit_provider.commerce': 'Commerce',
  'businessLineOfCredit_provider.other': other,
  'details.businessLineOfCredit_currentRate': `${detailsLoanHeader} Business Line of Credit | ${rate}`,

  'currentLoans.existingHomeLoan': 'Home',
  'currentLoans.existingHomeLoan.icon': '/classpath/assets/images/icons/icon-home-loan.svg',
  'existingHomeLoan.cardBuilder.title': 'Home',
  existingHomeLoan_currentBalance: balance,
  existingHomeLoan_monthlyPayment: moPayment,
  existingHomeLoan_currentRate: rate,
  'existingHomeLoan_currentRate.0to2': rate0,
  'existingHomeLoan_currentRate.2to3': rate2,
  'existingHomeLoan_currentRate.3to4': rate3,
  'existingHomeLoan_currentRate.4to5': rate4,
  'existingHomeLoan_currentRate.5to6': rate5,
  'existingHomeLoan_currentRate.6to7': rate6,
  'existingHomeLoan_currentRate.7to8': rate7,
  'existingHomeLoan_currentRate.8to9': rate8,
  'existingHomeLoan_currentRate.9to10': rate9,
  'existingHomeLoan_currentRate.10plus': rate10,
  'existingHomeLoan_currentRate.unknown': unknown,
  'details.existingHomeLoan_currentRate': `${detailsLoanHeader} Home | ${rate}`,

  'currentLoans.existingAutoLoan': 'Auto Loan',
  'currentLoans.existingAutoLoan.icon': '/classpath/assets/images/icons/icon-auto-loan.svg',
  'existingAutoLoan.cardBuilder.title': 'Auto Loan',
  existingAutoLoan_currentBalance: balance,
  existingAutoLoan_monthlyPayment: moPayment,
  existingAutoLoan_currentRate: rate,
  'existingAutoLoan_currentRate.0to2': rate0,
  'existingAutoLoan_currentRate.2to3': rate2,
  'existingAutoLoan_currentRate.3to4': rate3,
  'existingAutoLoan_currentRate.4to5': rate4,
  'existingAutoLoan_currentRate.5to6': rate5,
  'existingAutoLoan_currentRate.6to7': rate6,
  'existingAutoLoan_currentRate.7to8': rate7,
  'existingAutoLoan_currentRate.8to9': rate8,
  'existingAutoLoan_currentRate.9to10': rate9,
  'existingAutoLoan_currentRate.10plus': rate10,
  'existingAutoLoan_currentRate.unknown': unknown,
  'details.existingAutoLoan_currentRate': `${detailsLoanHeader} Auto Loan | ${rate}`,

  'currentLoans.existingCreditCard': 'Credit Card(s)',
  'currentLoans.existingCreditCard.icon': '/classpath/assets/images/icons/icon-credit-card.svg',
  'existingCreditCard.cardBuilder.title': 'Credit Card(s)',
  existingCreditCard_currentBalance: balance,
  existingCreditCard_monthlyPayment: moPayment,
  existingCreditCard_currentRate: rate,
  'existingCreditCard_currentRate.0to2': rate0,
  'existingCreditCard_currentRate.2to3': rate2,
  'existingCreditCard_currentRate.3to4': rate3,
  'existingCreditCard_currentRate.4to5': rate4,
  'existingCreditCard_currentRate.5to6': rate5,
  'existingCreditCard_currentRate.6to7': rate6,
  'existingCreditCard_currentRate.7to8': rate7,
  'existingCreditCard_currentRate.8to9': rate8,
  'existingCreditCard_currentRate.9to10': rate9,
  'existingCreditCard_currentRate.10plus': rate10,
  'existingCreditCard_currentRate.unknown': unknown,
  'details.existingCreditCard_currentRate': `${detailsLoanHeader} Credit Card(s) | ${rate}`,

  'currentLoans.existingPersonalLoan': 'Personal Loan',
  'currentLoans.existingPersonalLoan.icon': '/classpath/assets/images/icons/icon-bank-check.svg',
  'existingPersonalLoan.cardBuilder.title': 'Personal Loan',
  existingPersonalLoan_currentBalance: balance,
  existingPersonalLoan_monthlyPayment: moPayment,
  existingPersonalLoan_currentRate: rate,
  'existingPersonalLoan_currentRate.0to2': rate0,
  'existingPersonalLoan_currentRate.2to3': rate2,
  'existingPersonalLoan_currentRate.3to4': rate3,
  'existingPersonalLoan_currentRate.4to5': rate4,
  'existingPersonalLoan_currentRate.5to6': rate5,
  'existingPersonalLoan_currentRate.6to7': rate6,
  'existingPersonalLoan_currentRate.7to8': rate7,
  'existingPersonalLoan_currentRate.8to9': rate8,
  'existingPersonalLoan_currentRate.9to10': rate9,
  'existingPersonalLoan_currentRate.10plus': rate10,
  'existingPersonalLoan_currentRate.unknown': unknown,
  'details.existingPersonalLoan_currentRate': `${detailsLoanHeader} Personal Loan | ${rate}`,

  'currentLoans.existingHomeEquityLoan': 'Home Equity Loan',
  'currentLoans.existingHomeEquityLoan.icon': '/classpath/assets/images/icons/icon-retirement.svg',
  'existingHomeEquityLoan.cardBuilder.title': 'Home Equity Loan or Line of Credit',
  existingHomeEquityLoan_currentBalance: balance,
  existingHomeEquityLoan_monthlyPayment: moPayment,
  existingHomeEquityLoan_currentRate: rate,
  'existingHomeEquityLoan_currentRate.0to2': rate0,
  'existingHomeEquityLoan_currentRate.2to3': rate2,
  'existingHomeEquityLoan_currentRate.3to4': rate3,
  'existingHomeEquityLoan_currentRate.4to5': rate4,
  'existingHomeEquityLoan_currentRate.5to6': rate5,
  'existingHomeEquityLoan_currentRate.6to7': rate6,
  'existingHomeEquityLoan_currentRate.7to8': rate7,
  'existingHomeEquityLoan_currentRate.8to9': rate8,
  'existingHomeEquityLoan_currentRate.9to10': rate9,
  'existingHomeEquityLoan_currentRate.10plus': rate10,
  'existingHomeEquityLoan_currentRate.unknown': unknown,
  'details.existingHomeEquityLoan_currentRate': `${detailsLoanHeader} Home Equity Loan or Line of Credit | ${rate}`,

  'currentLoans.none': "None",
  'currentLoans.none.icon': '/classpath/assets/images/icons/icon-close.svg',

  businessSpace: "Do you own or lease your business space?",
  'businessSpace-group': "",
  'businessSpace.own': "Own",
  'businessSpace.lease': "Lease",
  'businessSpace.other': "Other",

  'purchaseLocation': 'Are you interested in purchasing your current location(s)?',
  'purchaseLocation.true': 'Yes',
  'purchaseLocation.false': 'No',

  /**
   * ============================
   * PRODUCT MESSAGES
   * ============================
   */

  'business-checking': 'Business Checking',
  'business-savings': 'Business Savings',
  'business-services': 'Business Services',
  'bill-payment-services': 'Bill and Payment Services',
  'business-lending': 'Business Lending',
  'business-credit-cards': 'Business Credit Cards',
  'digital-business-banking': 'Digital Business Banking',

  '2600.name': 'Small Business Options<sup>SM</sup> Checking',
  '2600.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2600.url': 'https://www.commercebank.com/business/checking/small-business-options-checking',
  '2600.description.abbreviated': 'We want to you be able to take advantage of the benefits you can receive because you maintain an average balance of ${answer__combinedDepositPlus}. This account type also provides the flexibility you need when it comes to free transactions and cash deposits.',
  '2600.description': 'We want to you be able to take advantage of the benefits you can receive because you maintain an average balance of ${answer__combinedDepositPlus}. This account type also provides the flexibility you need when it comes to free transactions and cash deposits.',
  '2600.features.count': 4,
  '2600.features.1': 'No monthly fee (with minimum balance<sup>1</sup>)',
  '2600.features.2': 'Balances from your other Commerce accounts provide you access to valuable benefits',
  '2600.features.3': 'Free Paperless Statements',
  '2600.features.4': 'Up to 300 free transactions a month<sup>2</sup>',
  '2600.disclosures.count': 3,
  '2600.disclosures.1': '$25,000 total deposit balances or $25,000 total loan balances or $40,000 total combined deposit and loan balances. $25 service charge each month minimum combined balance requirement is not met.',
  '2600.disclosures.2': 'First 300 transactions per statement cycle are free. These transactions include paper and electronic (ACH) debits, credits and deposited items, and Online Bill Pay-generated checks and ACH debits. Additional transactions are $0.50 each. The Business Visa Check Card is free, but the use of the products may count towards the account’s transaction limit.',
  '2600.disclosures.3': 'Other banks’ ATM fees and Commerce fee may apply when using non-Commerce ATMs.',

  '2602.name': 'myBusiness Select Checking',
  '2602.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2602.url': 'https://www.commercebank.com/business/checking/mybusiness-select-checking',
  // Note: commented descriptions in case, the dynamic one is requested again. 
  // '2602.description.abbreviated': 'myBusiness Select is the recommended checking product for your business based on your balance and transaction needs. Maintaining your current {answer__preText}{answer__combinedDepositCalcDescription} will allow you to waive the monthly service fee, receive up to 150 free transactions and cash deposits up to $10,000 free of charge.',
  // '2602.description': 'myBusiness Select is the recommended checking product for your business based on your balance and transaction needs. Maintaining your current {answer__preText}{answer__combinedDepositCalcDescription} will allow you to waive the monthly service fee, receive up to 150 free transactions and cash deposits up to $10,000 free of charge.',
  '2602.description.abbreviated': 'myBusiness Select is the recommended checking product for your business based on your balance and transaction needs. Maintaining a business balance of $2,500 or a combined business and personal deposit balance of $5,000 will allow you to waive the monthly service fee, receive up to 150 free transactions and cash deposits up to $10,000 free of charge.',
  '2602.description': 'myBusiness Select is the recommended checking product for your business based on your balance and transaction needs. Maintaining a business balance of $2,500 or a combined business and personal deposit balance of $5,000 will allow you to waive the monthly service fee, receive up to 150 free transactions and cash deposits up to $10,000 free of charge.',
  '2602.features.count': 4,
  '2602.features.1': 'No monthly fee when balance requirements met<sup>1</sup>',
  '2602.features.2': 'Balances from your other Commerce accounts provide you access to valuable benefits',
  '2602.features.3': 'Free unlimited Commerce ATM transactions<sup>2</sup>',
  '2602.features.4': 'Up to 150 free transactions a month<sup>3</sup>',
  '2602.disclosures.count': 3,
  '2602.disclosures.1': '$100 minimum to open. $2,500 minimum daily balance in myBusiness Select account or $5,000 in combined balances in business and personal deposit accounts: checking, savings and money market. If balances are not met, a $9.00 monthly fee applies. For complete details, ask for the Small Business Checking Fee Schedule.',
  '2602.disclosures.2': 'Other banks’ ATM fees and Commerce fee may apply when using non-Commerce ATMs.',
  '2602.disclosures.3': 'First 150 transactions per statement cycle are free. These transactions include paper and electronic (ACH) debits, credits and deposited items, and Online Bill Pay-generated checks and ACH debits. Additional transactions are $0.50 each. The Business Visa Debit Card is free, but the use of the products may count towards the account’s transaction limit.',

  '2604.name': 'myBusiness Checking',
  '2604.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2604.url': 'https://www.commercebank.com/business/checking/mybusiness-checking',
  // Note: commented descriptions since they will come back at some point. 
  // '2604.description.abbreviated': 'Based on your transaction needs (average {answer__totalTransactions} per month) and balance requirements (average monthly balance of ${answer__averageChecking}), we recommend a myBusiness Checking account for your business. This account gives you the same added free features as our other accounts for minimal or no charge.',
  // '2604.description': 'Based on your transaction needs (average {answer__totalTransactions} per month) and balance requirements (average monthly balance of ${answer__averageChecking}), we recommend a myBusiness Checking account for your business. This account gives you the same added free features as our other accounts for minimal or no charge.',
  '2604.description.abbreviated': 'Based on your transaction needs and your average balance of ${answer__averageChecking}, we recommend a myBusiness Checking account for your business. This account gives you the same added free features as our other accounts for minimal or no charge.',
  '2604.description': 'Based on your transaction needs and your average balance of ${answer__averageChecking}, we recommend a myBusiness Checking account for your business. This account gives you the same added free features as our other accounts for minimal or no charge.',
  '2604.features.count': 4,
  '2604.features.1': 'No monthly fee when eligibility requirements met<sup>1</sup>',
  '2604.features.2': 'No minimum balance',
  '2604.features.3': 'Free unlimited Commerce ATM transactions<sup>2</sup>',
  '2604.features.4': 'Up to 25 free transactions a month<sup>3</sup>',
  '2604.disclosures.count': 3,
  '2604.disclosures.1': '$100 minimum to open. Owner must maintain a personal checking account in order to waive the monthly fee. For details on which personal checking accounts are eligible, ask for the Small Business Checking Fee Schedule. If personal checking account is not maintained, a $5.00 monthly fee applies.',
  '2604.disclosures.2': 'Other banks’ ATM fees and Commerce fee may apply when using non-Commerce ATMs.',
  '2604.disclosures.3': 'First 25 transactions per statement cycle are free. These transactions include paper and electronic (ACH) debits, credits and deposited items, and Online Bill Pay-generated checks and ACH debits. Additional transactions are $0.50 each. The Business Visa Debit Card is free, but the use of the products may count towards the account’s transaction limit.',

  '2620.name': 'Merchant Services',
  '2620.icon': '/classpath/assets/images/icons/icon-summary-merchant.svg',
  '2620.url': 'https://www.commercebank.com/business/payables-and-receivables/receivables/merchant-services',
  '2620.description.abbreviated': 'As your business grows so does your need to have the right solution for you to receive credit and debit card payments from your customers. We recommend scheduling a consultation with our Merchant Services expert who will work with you to find the right solution that best fits your business needs.',
  '2620.description': 'As your business grows so does your need to have the right solution for you to receive credit and debit card payments from your customers. We recommend scheduling a consultation with our Merchant Services expert who will work with you to find the right solution that best fits your business needs.',
  '2620.features.count': 4,
  '2620.features.1': 'Wide selection of mobile, point-of-sale devices, and virtual terminals are available',
  '2620.features.2': 'Integration capabilities with many existing point-of-sale platforms',
  '2620.features.3': 'Accept payments in person, online, and over the phone',
  '2620.features.4': 'Improve your cash flow by offering invoicing, and recurring payment plan options',


  '2622.name': 'Remote Deposit',
  '2622.icon': '/classpath/assets/images/icons/icon-summary-remoteDeposit.svg',
  '2622.url': 'https://www.commercebank.com/business/payables-and-receivables/receivables/remote-deposit',
  '2622.description.abbreviated': 'Your business can have a teller-style check scanner in your office and an online portal to make deposits.  Because you deposit {answer__collectChecks} checks, which are typically over $7,500, this solution can help speed up deposits. It can also save you a trip to the branch, allowing multiple checks to be deposited at the same time, electronically endorse checks, and automatically saves deposit records and check images.',
  '2622.description': 'Your business can have a teller-style check scanner in your office and an online portal to make deposits.  Because you deposit {answer__collectChecks} checks, which are typically over $7,500, this solution can help speed up deposits. It can also save you a trip to the branch, allowing multiple checks to be deposited at the same time, electronically endorse checks, and automatically saves deposit records and check images.',
  '2622.features.count': 4,
  '2622.features.1': 'Make deposits from your office anytime',
  '2622.features.2': 'Ideal for businesses that receive 20+ checks per month',
  '2622.features.3': 'Access historical data to view and print images of deposited checks',
  '2622.features.4': 'First check scanner is free<sup>1</sup>',
  '2622.disclosures.count': 1,
  '2622.disclosures.1': 'One free base-model scanner per newly enrolled company; monthly service fee still applies; $30/mo. for most businesses and $15/mo. for Small Business Options account holders',

  '2624.name': 'Mobile Deposit',
  '2624.icon': '',
  '2624.url': 'https://www.commercebank.com/business/payables-and-receivables/receivables/remote-deposit',
  '2624.description.abbreviated': 'Deposit checks from any location, using your smart phone or tablet with the Commerce Bank Mobile Banking App! Commerce Mobile Deposit<sup>1</sup> lets you or your business online banking sub-users: Submit deposits 24/7, view previous and pending deposits, and reduce time away from your business with fewer trips to the bank. The Commerce Bank Mobile Banking App also lets you: View account balances and recent transaction history, transfer money between Commerce Bank accounts, and search for Commerce ATMs and branch locations.',
  '2624.description': 'Deposit checks from any location, using your smart phone or tablet with the Commerce Bank Mobile Banking App! Commerce Mobile Deposit<sup>1</sup> lets you or your business online banking sub-users: Submit deposits 24/7, view previous and pending deposits, and reduce time away from your business with fewer trips to the bank. The Commerce Bank Mobile Banking App also lets you: View account balances and recent transaction history, transfer money between Commerce Bank accounts, and search for Commerce ATMs and branch locations.',
  '2624.features.count': 2,
  '2624.features.1': 'Great for depositing less than 20 items per month',
  '2624.features.2': 'Remote online deposit checks from any location using your smart phone or tablet',
  '2624.disclosures.count': 1,
  '2624.disclosures.1': 'Requires Small Business Online Banking enrollment for 6 months to be eligible for Mobile Deposit',

  '2640.name': 'CashFlow Complete - Premium Bill Pay and Invoicing',
  '2640.icon': '/classpath/assets/images/icons/icon-summary-cashflow.svg',
  '2640.url': 'https://www.commercebank.com/business/payables-and-receivables/cashflow-complete',
  '2640.description.abbreviated': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up additional users, send recurring invoices, automatically debit customer’s accounts and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2640.description': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up additional users, send recurring invoices, automatically debit customer’s accounts and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2640.features.count': 4,
  '2640.features.1': 'Eliminate paper',
  '2640.features.2': 'Save time paying bills',
  '2640.features.3': 'Get paid faster',
  '2640.features.4': 'Reduce fraud',
  '2640.disclosures.count': 1,
  '2640.disclosures.1': 'Subscribers using NetSuite or Intacct Accounting Software should email SBB-BDC-Ops@CommerceBank.com for information on fees related to the implementation and synchronization of this software with CashFlow Complete.',

  '2642.name': 'CashFlow Complete - Deluxe Bill Pay',
  '2642.icon': '/classpath/assets/images/icons/icon-summary-cashflow.svg',
  '2642.url': 'https://www.commercebank.com/business/payables-and-receivables/cashflow-complete',
  '2642.description.abbreviated': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up additional users, automate approval workflows and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2642.description': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up additional users, automate approval workflows and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2642.features.count': 4,
  '2642.features.1': 'Eliminate paper',
  '2642.features.2': 'Save time paying bills',
  '2642.features.3': 'Get paid faster',
  '2642.features.4': 'Reduce fraud',
  '2642.disclosures.count': 1,
  '2642.disclosures.1': 'Subscribers using NetSuite or Intacct Accounting Software should email SBB-BDC-Ops@CommerceBank.com for information on fees related to the implementation and synchronization of this software with CashFlow Complete.',

  '2644.name': 'CashFlow Complete - Deluxe Invoicing',
  '2644.icon': '/classpath/assets/images/icons/icon-summary-cashflow.svg',
  '2644.url': 'https://www.commercebank.com/business/payables-and-receivables/cashflow-complete',
  '2644.description.abbreviated': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up recurring invoices, automatically debit customer’s accounts and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2644.description': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. With CashFlow Complete, you can not only pay and get paid, but you can also set up recurring invoices, automatically debit customer’s accounts and sync with your accounting software, ultimately saving you a significant amount of time.',
  '2644.features.count': 4,
  '2644.features.1': 'Eliminate paper',
  '2644.features.2': 'Save time paying bills',
  '2644.features.3': 'Get paid faster',
  '2644.features.4': 'Reduce fraud',
  '2644.disclosures.count': 1,
  '2644.disclosures.1': 'Subscribers using NetSuite or Intacct Accounting Software should email SBB-BDC-Ops@CommerceBank.com for information on fees related to the implementation and synchronization of this software with CashFlow Complete.',

  '2646.name': 'CashFlow Complete - Basic',
  '2646.icon': '/classpath/assets/images/icons/icon-summary-cashflow.svg',
  '2646.url': 'https://www.commercebank.com/business/payables-and-receivables/cashflow-complete',
  '2646.description.abbreviated': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. CashFlow Complete is a simple and easy-to-use online payment solution where you can pay your bills, invoice customers and receive payments directly to your bank account, right from within online banking.',
  '2646.description': 'As a business owner, you don’t have time to spend countless hours managing your financial operations. This is why it’s important to have a way to effectively and efficiently manage your payments. CashFlow Complete is a simple and easy-to-use online payment solution where you can pay your bills, invoice customers and receive payments directly to your bank account, right from within online banking.',
  '2646.features.count': 4,
  '2646.features.1': 'Eliminate paper',
  '2646.features.2': 'Save time paying bills',
  '2646.features.3': 'Get paid faster',
  '2646.features.4': 'Reduce fraud',
  '2646.disclosures.count': 1,
  '2646.disclosures.1': 'Subscribers using NetSuite or Intacct Accounting Software should email SBB-BDC-Ops@CommerceBank.com for information on fees related to the implementation and synchronization of this software  with CashFlow Complete.',

  '2660.name': 'Business Line of Credit',
  '2660.icon': '/classpath/assets/images/icons/icon-summary-loan.svg',
  '2660.url': 'https://www.commercebank.com/business/financing/financing-options/lines-of-credit',
  '2660.description.abbreviated': 'We understand you want to increase your cashflow and a Line of Credit can help with that. A Line of Credit allows you to borrow, repay, and re-borrow, similar to a revolving credit card. If you’d like to learn more, we can have our Small Business Specialist reach out to you.',
  '2660.description': 'We understand you want to increase your cashflow and a Line of Credit can help with that. A Line of Credit allows you to borrow, repay, and re-borrow, similar to a revolving credit card. If you’d like to learn more, we can have our Small Business Specialist reach out to you.',
  '2660.features.count': 4,
  '2660.features.1': 'Flexible repayment terms',
  '2660.features.2': 'Auto renewal (subject to credit approval)',
  '2660.features.3': 'Availability under SBA financing',
  '2660.features.4': 'Improve your cash balances',
  '2660.disclosures.count': 1,
  '2660.disclosures.1': 'Businesses must be located in Missouri, Kansas, Illinois, Oklahoma, or Colorado.',

  '2662.name': 'Commercial Real Estate Loan',
  '2662.icon': '/classpath/assets/images/icons/icon-summary-loan.svg',
  '2662.url': 'https://www.commercebank.com/business/financing/financing-options/real-estate-loans',
  '2662.description.abbreviated': 'You expressed interest in {answer__realEstateInterest}. Commercial Real Estate loans provide the needed capital for your business to expand and/or acquire business assets. We can explore the appropriate terms and rates that work best to meet your needs. If you’d like to learn more, we will have our Small Business Specialist contact you.',
  '2662.description': 'You expressed interest in {answer__realEstateInterest}. Commercial Real Estate loans provide the needed capital for your business to expand and/or acquire business assets. We can explore the appropriate terms and rates that work best to meet your needs. If you’d like to learn more, we will have our Small Business Specialist contact you.',
  '2662.features.count': 3,
  '2662.features.1': 'Help you to start building wealth in your own property',
  '2662.features.2': 'Find the space and functionality you need for your growing business',
  '2662.features.3': 'Creates the opportunity to stop improving someone else\'s property and start improving your own',
  '2662.disclosures.count': 1,
  '2662.disclosures.1': 'Businesses must be located in Missouri, Kansas, Illinois, Oklahoma, or Colorado.',

  '2664.name': 'Term Loan',
  '2664.icon': '/classpath/assets/images/icons/icon-summary-loan.svg',
  '2664.url': 'https://www.commercebank.com/business/financing/financing-options/term-loans',
  '2664.description.abbreviated': 'You indicated that you are interested in {answer__businessInterest}, and a term loan can provide the capital you need. We can work with you to determine the appropriate term and rates that make sense for your business. If you’d like to learn more, we will have our Small Business Specialist contact you.',
  '2664.description': 'You indicated that you are interested in {answer__businessInterest}, and a term loan can provide the capital you need. We can work with you to determine the appropriate term and rates that make sense for your business. If you’d like to learn more, we will have our Small Business Specialist contact you.',
  '2664.features.count': 3,
  '2664.features.1': 'Get the freedom to put your plans in motion',
  '2664.features.2': 'Build your business the way you want',
  '2664.features.3': 'Extended repayment periods for major purchases',
  '2664.disclosures.count': 1,
  '2664.disclosures.1': 'Term loans for small businesses must be located in Missouri, Kansas, Illinois, Oklahoma or Colorado.',

  '2680.name': 'Business Platinum Credit Card',
  '2680.icon': '/classpath/assets/images/icons/icon-summary-creditCard.svg',
  '2680.url': 'https://www.commercebank.com/business/cards/credit-cards',
  '2680.description.abbreviated': 'While paying off your credit card balance in full each month can help you avoid interest charges, we understand that isn’t always possible. This credit card offers a low interest rate which can be beneficial when you need to carry a balance from month to month.',
  '2680.description': 'While paying off your credit card balance in full each month can help you avoid interest charges, we understand that isn’t always possible. This credit card offers a low interest rate which can be beneficial when you need to carry a balance from month to month.',
  '2680.features.count': 3,
  '2680.features.1': 'No annual fee<sup>1</sup>',
  '2680.features.2': 'Low APR and extended grace period',
  '2680.features.3': 'Eliminates need for petty cash',
  '2680.disclosures.count': 1,
  '2680.disclosures.1': 'View Important terms of the Business Platinum Credit Card - <href>https://www.commercebank.com/-/media/cb/pdf/business/cards/business-platinum-agreement.pdf?revision=db6e4bf2-0c12-45d3-855e-87a758067737&modified=20180926203739&la=en&hash=ABEA9DF32C9AEF892882A9611AE5A8136C312C13||https://www.commercebank.com/-/media/cb/pdf/business/cards/business-platinum-agreement.pdf</href>',

  '2682.name': 'Business Rewards Credit Card',
  '2682.icon': '/classpath/assets/images/icons/icon-summary-creditCard.svg',
  '2682.url': 'https://www.commercebank.com/business/cards/credit-cards',
  '2682.description.abbreviated': 'In addition to earning points for your purchases, it’s always a good idea to separate your business expenses from your personal expenses and a credit card is an easy way to manage that. In addition to earning points for business purchases, you also have the option to add employees to your account who can have their own card at no additional cost to you. More people to earn more points! Credit limits can be customized for each employee and you’ll have peace of mind knowing that you have zero liability coverage<sup>1</sup> for any unauthorized spending by an employee.',
  '2682.description': 'In addition to earning points for your purchases, it’s always a good idea to separate your business expenses from your personal expenses and a credit card is an easy way to manage that. In addition to earning points for business purchases, you also have the option to add employees to your account who can have their own card at no additional cost to you. More people to earn more points! Credit limits can be customized for each employee and you’ll have peace of mind knowing that you have zero liability coverage<sup>1</sup> for any unauthorized spending by an employee.',
  '2682.features.count': 4,
  '2682.features.1': 'No annual fee<sup>2</sup>',
  '2682.features.2': 'Individual credit lines for employees',
  '2682.features.3': 'Quarterly bonus points<sup>3</sup>',
  '2682.features.4': 'Eliminates need for petty cash',
  '2682.disclosures.count': 3,
  '2682.disclosures.1': 'Customer must notify Commerce Bank within 60 days of receiving statement with unauthorized account activity. Company may not be liable for an Employee Cardholder transaction if the Business Rewards Credit Card charges are waived as set forth in Visa Waiver of Liability or MasterCard Zero Liability documentation, as amended from time to time. Visa’s Zero Liability policy covers U.S. issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa or certain Commercial Card transactions.',
  '2682.disclosures.2': 'Important Terms of the Business Rewards Credit Card. <href>https://www.commercebank.com/-/media/cb/pdf/business/cards/business-rewards-agreement.pdf?revision=965b6623-1702-4528-a26b-fa90928448bf&modified=20180926203739&la=en&hash=B8569E7D535F7355C0F0F8EE33E6DDB444C9FAAD||https://www.commercebank.com/-/media/cb/pdf/business/cards/business-rewards-agreement.pdf</href>',
  '2682.disclosures.3': 'To activate Quarterly Bonus Points and learn more about the promotion, visit <href>https://commercebank.com/rewards||commercebank.com/rewards</href> and click “Earn Points”.',

  '2684.name': 'Business Visa Debit Card',
  '2684.icon': '/classpath/assets/images/icons/icon-summary-debit.svg',
  '2684.url': 'https://www.commercebank.com/business/checking/business-debit-card',
  '2684.description.abbreviated': 'With this small business debit card, we give you the convenience and security to make being the boss a little bit easier.',
  '2684.description': 'With this small business debit card, we give you the convenience and security to make being the boss a little bit easier.',
  '2684.features.count': 3,
  '2684.features.1': 'Count on built-in fraud protection',
  '2684.features.2': 'Put your mind at ease with your Business Visa Debit Card\'s enhanced features',
  '2684.features.3': 'Pay your business bills the hassle-free way',

  '2685.name': 'Business Savings',
  '2685.icon': '/classpath/assets/images/icons/icon-summary-coins.svg',
  '2685.url': 'https://www.commercebank.com/business/solutions',
  '2685.description.abbreviated': 'Whether you’re wanting to earn interest or protect yourself against fraud, opening a Business Savings account can do both. You can manage the account online, schedule transfers to grow your balance or earn interest on your current funds.',
  '2685.description': 'Whether you’re wanting to earn interest or protect yourself against fraud, opening a Business Savings account can do both. You can manage the account online, schedule transfers to grow your balance or earn interest on your current funds.',
  '2685.features.count': 3,
  '2685.features.1': 'No monthly fee (with minimum balance*)',
  '2685.features.2': 'Interest earnings available**',
  '2685.features.3': 'For all business types',
  '2685.disclosures.count': 2,
  '2685.disclosures.1': `<div>The following terms apply to all Savings Accounts, including Money Market Accounts:</div>
    <ul>
      <li>The interest rate and annual percentage yield may change at our discretion at any time.</li>
      <li>Commerce Bank reserves the right to assess a fee for uncollected funds usage and overdrafts.</li>
      <li>If you close your account before interest is credited, you will not receive the accrued interest.</li>
      <li>Interest begins to accrue no later than the business day we receive credit for the deposit of non-cash items (i.e. checks).</li>
      <li>We use the daily balance method to calculate the interest on your account. This method applies a daily periodic rate to the ending collected balance in the account each day.</li>
      <li>Ledger balance includes all deposits of cash and non-cash items (i.e. checks) on the business day we receive the deposit.</li>
      <li>Pre-authorized or automatic transfers or withdrawals from the account, including telephone transfers and third party checks, are limited by law to six per statement cycle. Transfers between accounts of the depositor in person or by mail and withdrawals in person are unlimited.</li>
    </ul>`,
  '2685.disclosures.2': `<div>This fee schedule does not apply to unincorporated associations of natural persons for non-business purposes (i.e. softball teams, book clubs, investment clubs, etc.) For this type of account, see our fee schedule for personal accounts.</div>
    <div>*Daily balance refers to the ending ledger balance in the account each day. You must maintain the minimum daily balance every day of the monthly cycle.</div>
    <div>**Collected balance includes deposits of cash and checks drawn on Commerce Bank and non-cash items (i.e. checks) for which we have received credit in accordance with the availability schedule of the Federal Reserve Bank, local clearinghouse or correspondent bank.</div>`,

  // business add ons
  '2463.name': 'Small Business Online Banking',
  '2463.icon': '/classpath/assets/images/icons/icon-summary-phone.svg',
  '2463.url': 'https://www.commercebank.com/business/online-features/mobile-and-online-banking',
  '2463.description.abbreviated': 'Online Banking is a convenient and easy way to do your banking. Once you sign up for Online Banking, your Customer ID and Password will access Mobile Bankingp too.',
  '2463.description': 'Online Banking is a convenient and easy way to do your banking. Once you sign up for Online Banking, your Customer ID and Password will access Mobile Banking too.',
  '2463.features.count': 3,
  '2463.features.1': 'You can access your account information when it is convenient for you',
  '2463.features.2': 'Be in control of your cash flow with online transfers between accounts and online bill pay',
  '2463.features.3': 'Make money management easier with Alerts',

  '2464.name': 'Mobile Banking',
  '2464.icon': '/classpath/assets/images/icons/icon-summary-phone.svg',
  '2464.url': 'https://www.commercebank.com/business/online-features/mobile-and-online-banking ',
  '2464.description.abbreviated': 'Put your finances at your fingertips with the redesigned Commerce Bank Mobile Banking App.',
  '2464.description': 'Put your finances at your fingertips with the redesigned Commerce Bank Mobile Banking App.',
  '2464.features.count': 3,
  '2464.features.1': 'On the go account management at your fingertips',
  '2464.features.2': 'Deposit checks to your account from anywhere',
  '2464.features.3': 'Customize your experience',

  '2465.name': 'Paperless Statements',
  '2465.icon': '',
  '2465.url': 'https://www.commercebank.com/business/online-features/mobile-and-online-banking ',
  '2465.description.abbreviated': 'Sign up through Online Banking, and you will receive an email each month when your online account statement is available. You\’ll be able to login, view and print your Paperless Statements at any time.',
  '2465.description': 'Sign up through <href>https://banking.commercebank.com/cbi/login.aspx||Online Banking</href>, and you will receive an email each month when your online account statement is available. You\’ll be able to login, view and print your Paperless Statements at any time.',
  '2465.features.count': 3,
  '2465.features.1': '<b>Help the environment</b> - by reducing paper consumption',
  '2465.features.2': '<b>FREE</b> - for all Commerce Bank Online Banking customers',
  '2465.features.3': '<b>Now available for your Commerce Bank credit cards</b>',

  '2686.name': 'Deluxe Checks',
  '2686.icon': '',
  '2686.url': 'https://www.commercebank.com/personal/bank/checking/order-checks ',
  '2686.description.abbreviated': 'Order your business checks online, by phone or in a branch. Commerce\’s long-time check vendor, Deluxe, offers a variety of check products ranging from High Security checks that provide additional protection to mitigate fraud to Business Check Starter kits.',
  '2686.description': 'Order your business checks online, by phone or in a branch. Commerce\’s long-time check vendor, Deluxe, offers a variety of check products ranging from High Security checks that provide additional protection to mitigate fraud to Business Check Starter kits.',

  '2700.name': 'Trends & Insights',
  '2700.icon': '/classpath/assets/images/icons/icon-open-book.svg',
  '2700.description': 'Here is some useful information for your business. Check the links below and let us help your business to grow a little more!',
  '2700.description.abbreviated': 'Here is some useful information for your business. Check the links below and let us help your business to grow a little more!',
  '2700.addOns.count': 4,
  '2701.name': '<href>https://www.commercebank.com/business/trends-and-insights/2021/what-to-consider-in-a-business-checking-account || What to consider in a business checking account </href>',
  '2702.name': '<href>https://www.commercebank.com/business/trends-and-insights/2020/how-do-i-go-about-building-a-financial-nest-egg-for-my-business || How do I go about building a financial nest egg for my business </href>',
  '2703.name': '<href>https://www.commercebank.com/business/trends-and-insights/2019/mission-possible || Mission possible </href>',
  '2704.name': '<href>https://www.commercebank.com/business/trends-and-insights/2021/banking-solutions-to-better-manage-your-time || Banking solutions to better manage your time </href>',
  '2705.name': '<href>https://www.commercebank.com/business/trends-and-insights/2021/how-can-i-find-flexible-financing-for-my-business || How can I find flexible financing for my business </href>',
  '2706.name': '<href>https://www.commercebank.com/business/trends-and-insights/2021/how-can-i-find-flexible-financing-for-my-business || How can I find flexible financing for my business </href>',
  '2707.name': '<href>https://www.commercebank.com/business/trends-and-insights/2017/best-reward-for-money-management-is-more-rewards || Best reward for money management is more rewards </href>',
  '2708.name': '<href>https://www.commercebank.com/business/trends-and-insights/2022/4-reasons-why-clover-is-the-point-of-sale-solution-your-practice-needs || 4 Reasons why Clover is the point of sale solution for your practice needs </href>',

  '2720.name': 'Zelle®',
  '2720.icon': '/classpath/assets/images/icons/icon-summary-creditCard.svg',
  '2720.url': 'https://www.commercebank.com/personal/digital-banking/zelle',
  '2720.description.abbreviated': 'Zelle® is a fast and convenient way for you to send and receive payments. You can request<sup>1</sup> and accept payments from your customers as well as send payments to eligible vendors or suppliers<sup>2</sup>. Use Zelle® in your Commerce Bank Mobile App or Online Banking to send money directly from your bank account to theirs.',
  '2720.description': 'Zelle® is a fast and convenient way for you to send and receive payments. You can request<sup>1</sup> and accept payments from your customers as well as send payments to eligible vendors or suppliers<sup>2</sup>. Use Zelle® in your Commerce Bank Mobile App or Online Banking to send money directly from your bank account to theirs.',
  '2720.features.count': 3,
  '2720.features.1': 'Reduce trips to the bank to deposit cash and checks, instead receive payments, usually within minutes, directly in your bank account<sup>2</sup>',
  '2720.features.2': 'Ideal when you need to make small dollar payments to vendors and suppliers you know',
  '2720.features.3': 'No monthly fee for Commerce Bank small business customers',
  '2720.disclosures.count': 2,
  '2720.disclosures.1': 'Payment requests to persons not already enrolled with Zelle® must be sent to an email address.',
  '2720.disclosures.2': `U.S. checking or savings account required to use Zelle®. Transactions between enrolled users typically occur in minutes. To send or receive money with a small business, both parties must be enrolled with Zelle® directly through their financial institution’s online or mobile banking experience.
                          {br}
                          {br}
                          Zelle® and the Zelle® related marks are wholly owned by Early Warning Services, LLC and are used herein under license.`,

  '2730.name': 'Small Business Options Premium Money Market Account',
  '2730.icon': '/classpath/assets/images/icons/icon-summary-coins.svg',
  '2730.url': 'https://www.commercebank.com/business/solutions',
  '2730.description.abbreviated': 'Whether you’re wanting to earn interest or protect yourself against fraud, opening a Small Business Options Money Market account can do both. You can manage the account online, schedule transfers to grow your balance or earn interest on your current funds.',
  '2730.description': 'Whether you’re wanting to earn interest or protect yourself against fraud, opening a Small Business Options Money Market account can do both. You can manage the account online, schedule transfers to grow your balance or earn interest on your current funds.',
  '2730.features.count': 3,
  '2730.features.1': 'Higher interest earnings available for balances greater than 10K**',
  '2730.features.2': 'No monthly fee',
  '2730.features.3': 'No minimum balance',
  '2730.disclosures.count': 3,
  '2730.disclosures.1': `<div>The following terms apply to all Savings Accounts, including Money Market Accounts:</div>
    <ul>
      <li>The interest rate and annual percentage yield may change at our discretion at any time.</li>
      <li>Commerce Bank reserves the right to assess a fee for uncollected funds usage and overdrafts.</li>
      <li>If you close your account before interest is credited, you will not receive the accrued interest.</li>
      <li>Interest begins to accrue no later than the business day we receive credit for the deposit of non-cash items (i.e. checks).</li>
      <li>We use the daily balance method to calculate the interest on your account. This method applies a daily periodic rate to the ending collected balance in the account each day.</li>
      <li>Ledger balance includes all deposits of cash and non-cash items (i.e. checks) on the business day we receive the deposit.</li>
      <li>Pre-authorized or automatic transfers or withdrawals from the account, including telephone transfers and third party checks, are limited by law to six per statement cycle. Transfers between accounts of the depositor in person or by mail and withdrawals in person are unlimited.</li>
    </ul>`,
  '2730.disclosures.2': 'This fee schedule does not apply to unincorporated associations of natural persons for non-business purposes (i.e. softball teams, book clubs, investment clubs, etc.) For this type of account, see our fee schedule for personal accounts.',
  '2730.disclosures.3': '**Collected balance includes deposits of cash and checks drawn on Commerce Bank and non-cash items (i.e. checks) for which we have received credit in accordance with the availability schedule of the Federal Reserve Bank, local clearinghouse or correspondent bank.',

  // Consumer Checking Products 

  '2400.name': 'CommerceRelationship Checking',
  '2400.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2400.url': 'https://www.commercebank.com/personal/bank/checking/relationship-checking',
  '2400.descriptionAbbreviatedOnModal': 'true',
  '2400.description.abbreviated': 'An ideal checking account with added benefits for higher balances.',
  '2400.description':
    "An ideal checking account with added benefits for higher balances. Get a higher interest rate on your CommerceRelationship Checking account balances, a free Platinum Visa<sup>®</sup> Debit Card, free single/wallet-style Commerce Globe checks, a preferred rate on Premium Money Market Accounts and Certificates of Deposit<sup>1</sup>, no Commerce fee for ATM transactions nationwide, access to myRewards Savings and myRewards Money Market accounts, free Online Banking, Online Bill Pay, Mobile Banking<sup>2</sup> and Alerts, and have other banks' ATM fees refunded up to $10 per month<sup>3</sup>.  Customer must maintain a $5,000 average daily balance<sup>4</sup> in this account OR $15,000 in combined deposit balances (checking, savings, money market, and CD)<sup>4, 5</sup> to avoid a monthly service fee of $22.00.",
  '2400.features.count': 3,
  '2400.features.1': 'Provides you our best interest rates on your checking and savings balances.',
  '2400.features.2': 'Offers you the ability to bank the way you want with free access to Online Banking, Bill Pay, Mobile, text and email alerts, non-Commerce ATM fee reversals, free checks and a Platinum Visa Debit Card.',
  '2400.features.3': 'Use Zelle® to pay people by email or U.S. mobile phone instead of using cash or checks.',
  '2400.disclosures.count': 5,
  '2400.disclosures.1':
    'Commerce reserves the right to restrict or change. Preferred rate on PMMA balances greater than $10,000. Highest preferred rate on balances greater than $50,000. Preferred rate only valid on initial term of CD. You may request preferred rate at renewal.',
  '2400.disclosures.2':
    'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',
  '2400.disclosures.3':
    "Commerce will not charge you for ATM transactions made at non-Commerce ATMs. Other banks' fees will be refunded up to $10 per calendar month. Transactions must be from Commerce<b>Relationship</b> Checking account.",
  '2400.disclosures.4':
    'Average daily balance means the ending ledger balance in the account each day, divided by the number of days in the month. You must maintain the minimum average daily balance for the monthly cycle.',
  '2400.disclosures.5':
    'The person listed first on the account must maintain the combined balances shown. Qualifying deposit accounts include personal checking, savings, money market, CD, and retail IRAs. Business accounts do not qualify. Combined balances are determined by using the actual balance on the day prior to the checking account statement cycle date each month.',

  '2402.name': 'CommerceInterest Checking',
  '2402.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2402.url': 'https://www.commercebank.com/personal/bank/checking/interest-checking',
  '2402.descriptionAbbreviatedOnModal': 'true',
  '2402.description.abbreviated': 'An ideal checking account to earn interest and manage basic banking.',
  '2402.description':
    'CommerceInterest Checking is a convenient checking account with all the extras to bank when, where and how you want. With CommerceInterest Checking you can earn interest, receive free Online Banking, Online Bill Pay, and free Mobile Banking<sup>1</sup>, send and receive money with Zelle<sup>®</sup> and External Transfers<sup>2</sup>, and get a free Visa<sup>®</sup> Debit Card. CommerceInterest Checking also comes with free Commerce Bank ATM transactions, free email and text Alerts<sup>1</sup> to help you manage your account, and Access to myRewards Savings and myRewards Money Market accounts.',
  '2402.features.count': 4,
  '2402.features.1': 'You stated you have at least one direct deposit a month that exceeds $500.',
  '2402.features.1.rule':
    'hasAnsweredWith("depositType", {"directDeposit"}) and directDepositOver500 == true',
  '2402.features.2': 'You stated that your average checking balance exceeds $1,000.',
  '2402.features.2.rule': 'averageMonthlyCheckingBalance >= 1000',
  '2402.features.3': 'Offers you the ability to earn interest on your checking balance.',
  '2402.features.4':
    'Allows you to bank the way you want with free access to Online Banking, Bill Pay, Mobile, electronic statements, text and email alerts and a debit card.',
  '2402.disclosures.count': 2,
  '2402.disclosures.1':
    'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',
  '2402.disclosures.2': 'Fees may apply depending on the speed of the transaction.',

  '2453.name': 'Commerce Free Checking',
  '2453.icon': '/classpath/assets/images/icons/icon-summary-dda.svg',
  '2453.url': 'https://www.commercebank.com/personal/bank/checking/free-checking',
  '2453.descriptionAbbreviatedOnModal': 'true',
  '2453.description.abbreviated': 'A free checking account for basic banking needs.',
  '2453.description':
    'Commerce Free Checking is a simple checking account with all the extras to bank when, where and how you want. With Commerce Free Checking you get no minimum balance requirement, no monthly service charge, a free Visa<sup>®</sup> Debit Card, free Mobile Banking<sup>1</sup>, so you can bank whenever and wherever you want, free Commerce ATM transactions, free email and text Alerts<sup>1</sup> to help you manage your account,  access to myRewards Savings and myRewards Money Market accounts, free Online Banking and Online Bill Pay, and you can send and receive money with Zelle<sup>®</sup> and External Transfers<sup>2</sup>.',
  '2453.features.count': 2,
  '2453.features.1': 'No Monthly Service Charge to worry about.',
  '2453.features.2':
    'No minimum balance requirement to worry about.',
  '2453.disclosures.count': 2,
  '2453.disclosures.1':
    'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',
  '2453.disclosures.2': 'Fees may apply depending on the speed of the transaction.',

  // Cross-sell addon products

  '2405.name': 'Online Banking',
  '2405.description.abbreviated': 'Online Banking is a convenient and easy way to do your banking. Once you sign up for Online Banking, your Customer ID and Password will access Mobile Banking<sup>1</sup> too.',
  '2405.description':
    "Online Banking is a convenient and easy way to do your banking. Once you sign up for Online Banking, your Customer ID and Password will access Mobile Banking<sup>1</sup> too." +
    "<ul>" +
    "<li>View your account activity and balances</li>" +
    "<li>Send and receive money fast with Zelle®</li>" +
    "<li>Make money management easier with <href>https://www.commercebank.com/personal/online-features/alerts-faqs||Alerts</href><sup>1</sup></li>" +
    "<li>Pay bills from your desktop with <href>https://www.commercebank.com/personal/online-features/payment-technology||Online Bill Pay</href>  – You can also pay bills with Mobile Banking once you've enrolled and set up payees on the desktop.</li>" +
    "<li>Move money the easy way - transfer funds internally between your Commerce Bank accounts and use <href>https://www.commercebank.com/personal/online-features/external-transfers-faqs||External</href> Transfers to transfer funds between your Commerce accounts and accounts held at other Financial Institutions<sup>2</sup></li>" +
    "</ul>",
  '2405.disclosures.count': 2,
  '2405.disclosures.1': 'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',
  '2405.disclosures.2': 'Fees may apply depending on the speed of the transaction.',
  '2405.disclosures.subtext': 'Zelle® and the Zelle® related marks are wholly owned by Early Warning Services, LLC and are used herein under license.',

  '2407.name': 'Online Bill Pay',
  '2407.description.abbreviated': 'Online Bill Pay is a quick and easy way to organize and pay your bills any time. Payments can be made through Online Banking or Mobile Banking<sup>1</sup>.',
  '2407.description':
    "Online Bill Pay is a quick and easy way to organize and pay your bills any time. Payments can be made through Online Banking or Mobile Banking<sup>1</sup>."
    + "<ul>"
    + "<li>Pay bills for free</li>"
    + "<li>Make payments quickly – it just takes seconds and your payments will be delivered in as little as two days</li>"
    + "<li>View your payment history</li>"
    + "<li>Schedule payments when it's convenient for you – make one-time or repeating payment</li>"
    + "<li>Receive email reminders when bills are due</li>"
    + "<li>Get your bills delivered to you online through E-bills</li>"
    + "<li>Choose Same-Day Bill Pay option and make a payment with the fastest processing time available<sup>2</sup></li>"
    + "</ul>",
  '2407.disclosures.count': 2,
  '2407.disclosures.1': 'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',
  '2407.disclosures.2': 'Fees apply. See <href>https://www.commercebank.com/personal/digital-banking/online-banking-terms-and-conditions||Online Banking Terms & Conditions</href> for details.',

  '2409.name': 'Online Banking Alerts',
  '2409.description.abbreviated': 'Alerts<sup>1</sup> allow you to better manage your checking, savings and money market accounts through email and text notifications.',
  '2409.description': 'Account Alerts<sup>1</sup> notify you of specific account activity that has taken place within your account including: <ul><li>Your balance has fallen below the amount you specified</li><li>Your balance is above the amount you specified</li><li>A direct deposit has been received</li><li>A withdrawal or debit card purchase has been made greater than the threshold you specified</li><li>Your account has become overdrawn</li><li>Overdraft protection has been activated</li></ul>',
  '2409.disclosures.count': 1,
  '2409.disclosures.1': 'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',

  '2709.name': 'Personal Checks',
  '2709.description.abbreviated': 'Several check options are available through our partner Deluxe.  You can choose a quantity that works best for you, depending on how often you write checks.',
  '2709.description': 'Several check options are available through our partner Deluxe.  You can choose a quantity that works best for you, depending on how often you write checks. For new customers, check orders must be placed at the branch or through Online Banking.',

  '2406.name': 'Mobile Banking',
  '2406.description.abbreviated': 'Put your finances at your fingertips with the redesigned Commerce Bank Mobile Banking App<sup>1</sup>.',
  '2406.description': "Put your finances at your fingertips with the redesigned Commerce Bank Mobile Banking App<sup>1</sup>. Based on your feedback, we've added the following features to deliver our most intuitive update yet:<ul><li><strong>Lock and unlock cards</strong> Save a phone call and immediately freeze your misplaced Commerce Bank debit or credit card as soon as you realize it's gone.</li> <li><strong>Customize your experience</strong>  Access your most-used accounts at the top of the app, or however else you prefer. For a personal touch, add a favorite picture to your profile.</li><li><strong>View check images</strong> You can now see who you paid – not just how much – with visual confirmation of a successful check payment from within the mobile app.</li><li><strong>Access your information with a touch… or a glance</strong> Pull up your accounts in an instant with the security of your unique fingerprint. Users of the iPhone X will benefit from its facial recognition technology.</li></ul>",
  '2406.disclosures.count': 1,
  '2406.disclosures.1': 'Message and data usage fees may apply; check with your wireless or VoIP provider for more information.',

  '2408.name': 'Paperless Statements',
  '2408.description.abbreviated': "Sign up through <href>https://banking.commercebank.com/cbi/login.aspx||Online Banking</href>, and you will receive an email each month when your online account statement is available. You'll be able to login, view and print your Paperless Statements at any time.",
  '2408.description': "Sign up through <href>https://banking.commercebank.com/cbi/login.aspx||Online Banking</href> and you will receive an email each month when your online account statement is available. You'll be able to login, view and print your Paperless Statements at any time. With Paperless from Commerce Bank, you can: <ul><li><strong>Eliminate paper clutter</strong> – organize account statements electronically.</li><li><strong>Access up to 7 years of statements</strong> – open statements online in one convenient location.</li><li><strong>View statements as soon as they're available</strong> – stop waiting for the mail.</li><li><strong>Protect yourself against identity theft</strong> – feel safer with less paper to shred and fewer account documents in your mailbox.</li></ul>",

  '2411.name': 'Platinum Visa<sup>®</sup> Debit Card',
  '2411.description.abbreviated': 'Enjoy the added value of a Commerce Bank Platinum Visa<sup>®</sup> Debit Card which accompanies certain types of checking accounts like <href>https://www.commercebank.com/personal/bank/checking/relationship-checking || CommerceRelationship Checking</href>. You get all the benefits of a debit card including <href>https://www.commercebank.com/security-center/cardholder-security || Zero Liability Protection</href><sup>1</sup> plus much more. Choose a second card design to avoid confusion between debit cards for accounts with more than one card.',
  '2411.description':
    "Whatever you need, Visa Debit is a great way to pay. From the donut shop to the drug store, you can use your card at millions of places that accept Visa Debit Cards. So it's perfect for those little purchases you make every day."
    + "<ul>"
    + "<li><strong>Skip the ATM – and save time.</strong> By using your card instead of cash, you eliminate extra trips to the ATM. Plus avoid paying ATM fees for out-of-network withdrawals. It's a simple way to save time and money every day.</li>"
    + "<li><strong>Count on built-in fraud protection.</strong> Unlike cash, you're protected if your card is ever lost or stolen with <href>https://www.commercebank.com/security-center/identity-theft-and-fraud/protecting-yourself || Visa Zero Liability</href><sup>1</sup></li>"
    + "<li><strong>Lock Your Card.</strong> Use Online Banking to temporarily block new purchases and ATM withdrawals, without interrupting recurring payments. When you find your card, just unlock it and begin using it again. <href>https://www.commercebank.com/security-center || Log in to Online Banking</href> to manage your card.</li>"
    + "<li><strong>Get your Card instantly.</strong><sup>2</sup> No more waiting for your card to arrive in the mail. Replace a lost, stolen or damaged card quickly. Simply visit one of our <href>https://locations.commercebank.com/locations/ || participating branches</href>.</li>"
    + "<li><strong>Now available a second choice.</strong> Choose a second card design to avoid confusion between debit cards for accounts with more than one card.</li>"
    + "</ul>",
  '2411.disclosures.count': 2,
  '2411.disclosures.1': 'Customer must notify Commerce Bank within 60 days of receiving the first statement with unauthorized activity. For specific restrictions, limitations and other details, please consult Commerce Bank.',
  '2411.disclosures.2': 'Some restrictions may apply.',

  '2740.name': 'My Savings Accelerator Tools',
  '2740.description': `
  My Savings Accelerator tools from Commerce Bank make saving simple. With tools like SmartSave and Round Up, you can take control of your strategy, remove the guesswork, and make saving effortless.
  {br}{br}
  SmartSave is an automated savings program that uses predictive technology to analyze your incoming deposits and transaction patterns to identify when you have extra funds that can be safely moved from your checking to your designated Commerce savings account. Before you know it, you’re saving money like never before — and we’re doing all the work for you!
  {br}{br}
  Round Up helps you save by rounding up your debit card purchase amounts to the nearest dollar. Your Round Up amount is automatically transferred to your designated Commerce savings account. Plus, you can choose the amount you Round Up.
  `,
  '2740.disclosures.count': 1,
  '2740.disclosures.1': '<href>https://www.commercebank.com/olb/my-savings-accelerator-terms || https://www.commercebank.com/olb/my-savings-accelerator-terms</href>',

};
